import { DELETE_SHARE_IMAGE_SUCCESS, DELETE_USER_AVATAR_SUCCESS, GET_TERRITORY_TYPES_SUCCESS, GET_USER_SHARE_SETTINGS_SUCCESS, UPDATE_SAVE_PROFILE_LOADING, UPDATE_SHARE_IMAGE_SUCCESS, UPDATE_TERRITORY_TYPE_ADMIN_ONLY_SUCCESS, UPDATE_USER_AVATAR_SUCCESS, UPDATE_USER_PROFILE_SUCCESS, UPDATE_USER_SHARE_SETTINGS_SUCCESS, USER_UPDATE_ACTIVE_STATUS_FAILURE, USER_UPDATE_ACTIVE_STATUS_SUCCESS } from "../Actions/Types";

import { IUserShareSettings } from "../Models/IUserShareSettings";
import { ITerritoryType, IUser } from "../Models/Models";
import { IOktaMFAFactor } from "../Models/OktaModels/IOktaMFAFactor";
import { GET_ALL_USERS_SUCCESS,
    GET_USER_SUCCESS,
    SET_LOADING_ALL_USERS,
    SET_SHOW_ACTIVE_USERS
} from "../View/Products/Types/UserActionTypes";

export interface IUserReducerState {
  user: IUser;
  allUsers: IUser[];
  companyTerritoryTypes: ITerritoryType[];
  userMFAFactors: IOktaMFAFactor[];
  waitingForMFAResponse: boolean;
  saveProfileLoading: boolean;
  shareSettings: IUserShareSettings;
  showActiveUsers: boolean;
  loadingAllUsers: boolean;
}

export const defaultState: IUserReducerState = {
    user: null,
    allUsers: null,
    companyTerritoryTypes: [],
    userMFAFactors: null,
    waitingForMFAResponse: false,
    saveProfileLoading: false,
    shareSettings: null,
    showActiveUsers: false,
    loadingAllUsers: false,
};

export const user = (
    state: IUserReducerState = { ...defaultState },
    action
): IUserReducerState => {
    switch (action.type) {
        /** misc */
        case SET_SHOW_ACTIVE_USERS: {
            return {
                ...state,
                showActiveUsers: action.data as boolean,
            };
        }
        case SET_LOADING_ALL_USERS: {
            return {
                ...state,
                loadingAllUsers: action.data as boolean,
            };
        }
        case GET_USER_SUCCESS: {
            return {
                ...state,
                user: action.data as IUser
            };
        }
        case GET_ALL_USERS_SUCCESS: {
            return {
                ...state,
                allUsers: action.data as IUser[] || []
            };
        }
        case USER_UPDATE_ACTIVE_STATUS_SUCCESS: {
            const allUsersCopy: IUser[] = [...state.allUsers];
            for (let i = 0; i < allUsersCopy.length; i++) {
                if (allUsersCopy[i].userID === action.response.data.userID) {
                    allUsersCopy[i].isActive = action.response.data.isActive;
                    break;
                }
            }

            return Object.assign({}, state, {
                allUsers: allUsersCopy,
            });
        }
        case UPDATE_TERRITORY_TYPE_ADMIN_ONLY_SUCCESS: {
            const companyTerritoryTypesCopy: Array<ITerritoryType> = [
                ...state.user.company.territoryTypes.types,
            ];
            for (let i = 0; i < companyTerritoryTypesCopy.length; i++) {
                if (companyTerritoryTypesCopy[i].typeID === action.response.data) {
                    companyTerritoryTypesCopy[i].isAdminOnly
            = !companyTerritoryTypesCopy[i].isAdminOnly;
                    // update SCOUT
                    (window as any).scout.logic.TerritoryLogic.fnTerritoryTypeUpdated(
                        companyTerritoryTypesCopy[i]
                    );
                    break;
                }
            }

            return {
                ...state,
                companyTerritoryTypes: companyTerritoryTypesCopy,
            };
        }
        case UPDATE_SAVE_PROFILE_LOADING: {
            return {
                ...state,
                saveProfileLoading: action.data,
            };
        }
        /**
     * this is a "maybe" success
     * the server call will probably succeed, but there some validation that would still mean that nothing was updated
     */
        case UPDATE_USER_PROFILE_SUCCESS: {
            // update the 'allUsers' array
            const allUsersCopy: IUser[] = [...state.allUsers];
            for (let i = 0; i < allUsersCopy.length; i++) {
                if (allUsersCopy[i].userID === action.response.data.userID) {
                    allUsersCopy[i] = action.response.data;
                    break;
                }
            }

            // update the logged in user
            const userCopy: IUser = { ...state.user };
            userCopy.userName = action.response.data.userName;
            userCopy.firstName = action.response.data.firstName;
            userCopy.lastName = action.response.data.lastName;
            userCopy.email = action.response.data.email;
            userCopy.phone = action.response.data.phone;
            userCopy.fullName = action.response.data.fullName;
            userCopy.shareImage = action.response.data.shareImage;

            return {
                ...state,
                user: userCopy,
                allUsers: allUsersCopy
            };
        }

        case UPDATE_USER_AVATAR_SUCCESS: {

            const userCopy: IUser = { ...state.user };
            userCopy.profileImage = action.response.data;

            const allUsersCopy: IUser[] = state.allUsers
                .map(u => u.userID === userCopy.userID
                    ? userCopy
                    : u);

            return {
                ...state,
                user: userCopy,
                allUsers: allUsersCopy
            };
        }

        case UPDATE_SHARE_IMAGE_SUCCESS: {

            const userCopy: IUser = { ...state.user };
            userCopy.shareImage = action.response.data;

            const allUsersCopy: IUser[] = state.allUsers
                .map(u => u.userID === userCopy.userID
                    ? userCopy
                    : u);

            return {
                ...state,
                user: userCopy,
                allUsers: allUsersCopy
            };
        }

        case DELETE_USER_AVATAR_SUCCESS: {
            const userCopy: IUser = { ...state.user };
            userCopy.profileImage = null;

            const allUsersCopy: IUser[] = [...state.allUsers];

            for (let i = 0; i < allUsersCopy.length; i++) {
                if (allUsersCopy[i].userID === userCopy.userID) {
                    allUsersCopy[i].profileImage = null;
                    break;
                }
            }

            return {
                ...state,
                user: userCopy,
                allUsers: allUsersCopy
            };
        }

        case DELETE_SHARE_IMAGE_SUCCESS: {
            const userCopy: IUser = { ...state.user };
            userCopy.shareImage = null;

            const allUsersCopy: IUser[] = [...state.allUsers];

            for (let i = 0; i < allUsersCopy.length; i++) {
                if (allUsersCopy[i].userID === userCopy.userID) {
                    allUsersCopy[i].shareImage = null;
                    break;
                }
            }

            return {
                ...state,
                user: userCopy,
                allUsers: allUsersCopy
            };
        }

        case GET_TERRITORY_TYPES_SUCCESS: {
            const userCopy: IUser = { ...state.user };
            userCopy.company.territoryTypes.types = action.response.data;

            return {
                ...state,
                user: userCopy
            };
        }

        case GET_USER_SHARE_SETTINGS_SUCCESS: {
            return {
                ...state,
                shareSettings: action.data.data as IUserShareSettings,
            };
        }

        case UPDATE_USER_SHARE_SETTINGS_SUCCESS: {
            return {
                ...state,
                shareSettings: action.data.data as IUserShareSettings,
            };
        }
        // FAILURE
        case USER_UPDATE_ACTIVE_STATUS_FAILURE:
        default:
            return state;
    }
};
